module.exports = __webpack_public_path__ + "static/group-3-c19e8c791d22852a5c0c964326bb2d45.jpg";